module.exports = __webpack_public_path__ + "static/media/38molinarmetro2.a2f0ac5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/38molinarmetro2.png
// module id = 130
// module chunks = 0